<template>
  <div>
    <h3 class="mb-5">
      Representative Details
    </h3>

    <validation-observer
      ref="formValidation"
      v-slot="{ handleSubmit }"
    >
      <b-form
        novalidate
        @submit.stop.prevent="handleSubmit(onSubmit)"
      >
        <b-form-row>
          <b-col>
            <BaseFormInput
              id="firstName"
              v-model="details.firstName"
              name="First Name"
              placeholder="Enter First Name"
              label="First Name"
              type="text"
              required
            />
          </b-col>

          <b-col>
            <BaseFormInput
              id="lastName"
              v-model="details.lastName"
              name="Last Name"
              label="Last Name"
              placeholder="Enter Last Name"
              type="text"
              required
            />
          </b-col>
        </b-form-row>

        <BaseFormInput
          id="email"
          v-model.trim="details.email"
          name="Email"
          label="Email"
          placeholder="Enter Email"
          type="email"
          rules="email"
          required
          @blur="transformInput"
        />        

        <BaseFormInput
          id="cellPhone"
          v-model="details.cellPhone"
          name="Cell Phone"
          label="Phone Number"          
          placeholder="Enter phone number (Optional)"
          type="tel"
          :formatter="phoneNumberFormatter"
          :debounce="500"
          rules="phone"          
        />

        <b-form-row>
          <b-col           
            sm
          >
            <BaseFormSelect
              id="social_media_platform"
              v-model="details.socialMediaPlatform"             
              name="Social media platform"
              label="Social media platform"
              text-field="name"
              value-field="id"
              :small="true"
              :options="socialMediaPlatforms"             
            />
          </b-col><b-col     
            v-if="details.socialMediaPlatform"      
            sm
          >
            <BaseFormInput            
              id="socialMediaHandle"
              v-model="details.socialMediaHandle"                
              :placeholder="'Enter ' + socialMediaPlatforms.find((x) => x.id === details.socialMediaPlatform).name + ' handle'"
              :small="true"
              label="Social media handle"
              type="text"
            /> 
          </b-col>
        </b-form-row>
       
        <div class="justify-content-center d-flex">
          <BaseButtonLoader
            button-class="custom-button--white-hover-grad pulse mr-3"
            @click="onBack"
          >
            Back
          </BaseButtonLoader>

          <BaseButtonLoader
            button-class="custom-button--white-hover-grad pulse"
            type="submit"
          >
            Next
          </BaseButtonLoader>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import formInputMixin from '@/mixins/formInputMixin'
import {  mapActions } from 'vuex'

export default {
  name: 'RepresentativeDetailsForm',

  mixins: [formInputMixin],

  data() {
    return {
      details: {
        firstName: '',
        lastName: '',
        email: '',
        skype: '',
        cellPhone: '',
        socialMediaPlatform: '',
        socialMediaHandle: ''
      },
      socialMediaPlatforms:  [
        {name: 'None', id: null},
        {name:"WhatsApp",id:"whatsapp"},
        {name:"Telegram",id:"telegram"},
        {name:"Microsoft Teams",id:"msteams"},
        {name:"Facebook",id:"facebook"},
        {name:"Instagram",id:"instagram"},
      ]
    }
  },  

  methods: {
    ...mapActions('registration', ['setRepresentativeDetails']),

    onSubmit() {      
      this.transformInput()
      this.setRepresentativeDetails({...this.details})
      this.$emit('submit')
    },

    onBack() {
      this.$emit('back')
    },

    transformInput() {
      this.details = {
        ...this.details,
        email: this.details.email.trim().toLowerCase(),
        skype: this.getSocialMedia()
      }
    },

    getSocialMedia() {
      if (this.details.socialMediaPlatform && this.details.socialMediaHandle){
        return this.details.socialMediaPlatform + ":" + this.details.socialMediaHandle
      }
      return null
    }
  },
}
</script>

<style>

</style>